<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/wG1CcE/image/cover.jpg?1730053910893" alt="This image is the cover for the book Bitterman's Craft Salt Cooking"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Bitterman's Craft Salt Cooking
      </h1>
      <p class="bookDescription body article font2">
        <b>The James Beard Award-winning author of <i>Salted</i> presents more than sixty recipes showcasing a range of natural, healthful, hand-crafted salts.</b><br/><br/>Today, our planet is home to hundreds of craft salts, each reflecting its own native ecology and culinary traditions. In terms of flavor, nutrition, and sustainability, these salts are a world apart from your typical iodized, kosher, or even industrially manufactured sea salt. Now salt expert Mark Bitterman offers a master class in craft salt—from rock salt and fleur de sel to the many smoked and infused varieties—in this unique and enlightening cookbook.<br/><br/>Mark introduces the different varieties of craft salt with convenient charts that make it easy to find the right salt for the right food. The recipes cover everything from Meat, Poultry, and Seafood to Sweets, Cocktails, and more. You’ll enjoy mouthwatering dishes like Colorado Beef Burgers with Mesquite Smoked Salt; Truffle Salt Smashed Roasted Potatoes; and Salted Latte Ice Cream with Lemon Espresso Drizzle. Plus, Mark’s the tips, techniques, and suggestions will help you elevate your own favorite dishes with the magic of craft salt.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Mark Bitterman
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Andrews McMeel Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?28454ac2